import { useContext } from "react";

import LaunchDarklyContext from "./launchDarklyProvider";

export const useIdentifyQueueItContext = () =>
  useContext(LaunchDarklyContext).identifyQueueItContext;
